import { Pipe, PipeTransform } from "@angular/core";

export type TzFormat = 'date' | 'time' | 'both' | 'comma';

/**
 * Formats a given date or timestamp for a specific timezone
 */
@Pipe({
    name: 'tzAbbr'
})
export class TimezoneAbbrPipe implements PipeTransform {
    transform(value: Date | string, timeZone: string = "UTC", format: TzFormat = 'both'): string {
        const date = new Date(value);
        const datePart = date.toLocaleDateString('en-US', {
            timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
        const timePart = date.toLocaleTimeString('en-US', {
            timeZone,
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
            timeZoneName: 'short'
        })
        switch(format) {
            case 'date':
                return datePart;
            case 'time':
                return timePart;
            case 'comma':
                return `${datePart}, ${timePart}`;
            case 'both':
            default:
                return `${datePart} ${timePart}`;
        }
    }
}